import { api } from "api";

export const getFaq = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/faqs")
      .then((res) => {
        dispatch({
          type: "GET_FAQ_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_FAQ_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
